import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=0b3f0ce3&scoped=true"
import script from "./ErrorScreen.vue?vue&type=script&lang=js"
export * from "./ErrorScreen.vue?vue&type=script&lang=js"
import style0 from "./ErrorScreen.vue?vue&type=style&index=0&id=0b3f0ce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f0ce3",
  null
  
)

export default component.exports